/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import bind from 'apmui/decorators/bind';
import { IWebtopResourceModel } from 'apmui/resource';
import LaunchType from 'apmui/resource/LaunchType';
import onKeyPress from 'apmui/util/onKeyPress';
import App from 'apmui/App';
import SpinnerImage from 'apmui/components/SpinnerImage';
import WebtopResourceModel, { LaunchStatus } from 'apmui/resource/WebtopResourceModel';

const app = App.get();

function limitSize(str: string, num: number = 41) {
    return str.length > num ? str.substr(0, num - 1) + '...' : str;
}

interface IWebtopResourceProps {
    resource: IWebtopResourceModel;
    /* id of current webtop section */
    section?: string;
    /* override for launch event */
    onLaunch?: (resource: IWebtopResourceModel) => boolean;
}

class WebtopResourceView extends React.Component<IWebtopResourceProps> {
    @bind
    onClick() {
        if (!this.props.onLaunch || !this.props.onLaunch(this.props.resource)) {
            app.launchResource(this.props.resource);
        }
    }

    @bind
    onRestart(evt: React.SyntheticEvent) {
        evt.stopPropagation();
        app.launchResource(this.props.resource, { launchType: LaunchType.RESTART });
    }

    overlay(resource: IWebtopResourceModel) {
        if (resource.iconOverlay) {
            /* Replace IN_PROGRESS gif image with customizable SVG */
            if (resource.iconOverlay === WebtopResourceModel.statusOverlayIcons[LaunchStatus.IN_PROGRESS]) {
                return <SpinnerImage className="overlay" />;
            }
            return <img className="overlay" src={resource.iconOverlay} alt="" />;
        }
        return null;
    }

    render() {
        const resource = this.props.resource;
        // TODO: add tooltip text to resource.iconOverlay
        return (
            <div
                className="apmui-webtop-resource"
                id={resource.type + ':' + resource.id}
                onClick={this.onClick}
                onKeyPress={onKeyPress(this.onClick)}
                tabIndex={0}
                role="link"
                area-label={limitSize(resource.caption)}>
                <div className="apmui-webtop-resource--caption-container">
                    <span className="apmui-webtop-resource--icon">
                        <img src={resource.icon} alt="" />
                        {this.overlay(resource)}
                    </span>
                    <span className="apmui-webtop-resource--caption">{limitSize(resource.caption)}</span>
                </div>
                <div className="apmui-webtop-resource--description">{limitSize(resource.description, 80)}</div>
                {'restartUri' in this.props.resource && this.props.resource.restartUri && (
                    <button
                        className="apmui-webtop-resource--restart"
                        title="Launch with restart"
                        onClick={this.onRestart}
                    />
                )}
            </div>
        );
    }
}

export { WebtopResourceView as default, IWebtopResourceProps };
